import { getModuleFromUserContext, getParameterFromUserContextModule } from "@tm/context-distribution"
import { UserContext, UserModuleType } from "@tm/models"

export function isAutocompleteEnabled(userContext: UserContext): boolean {
    return !!getModuleFromUserContext(userContext, UserModuleType.Autocomplete)
}

export function shouldUseVersion2(userContext: UserContext): boolean {
    return getParameterFromUserContextModule(userContext, UserModuleType.Autocomplete, "Version", "string") === "2"
}
